import { render, staticRenderFns } from "./ComponentBox.vue?vue&type=template&id=22f17f7b&scoped=true"
import script from "./ComponentBox.vue?vue&type=script&lang=js"
export * from "./ComponentBox.vue?vue&type=script&lang=js"
import style0 from "./ComponentBox.vue?vue&type=style&index=0&id=22f17f7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f17f7b",
  null
  
)

export default component.exports